import { ResponseDataGet } from "../../../../models/responseDataGet";
import { agroApi } from "../../api";
import { Paths } from "../../../../paths";
import { EntInitialFilter } from "../../../../models/filters/initialFilter";
import { EntBasicHB } from "../../../../models/handBooks/basicHB";

export const legalFormApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getLegalFormList: builder.query<ResponseDataGet<EntBasicHB>, EntInitialFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.legalForm }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getLegalFormById: builder.query<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.legalForm }/${ id }`,
		method: 'GET',
	  }),
	}),

	addLegalForm: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.legalForm }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editLegalForm: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.legalForm }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteLegalForm: builder.mutation<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.legalForm }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddLegalFormMutation,
  useDeleteLegalFormMutation,
  useEditLegalFormMutation,
  useGetLegalFormByIdQuery,
  useGetLegalFormListQuery,
  useLazyGetLegalFormListQuery
} = legalFormApi;
